<template>
  <v-dialog v-model="display">
    <v-card>
      <v-card-title>
        <v-title>The following orders require attention</v-title>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="rows">
          <template slot="items" slot-scope="props">
            <td>
              <v-btn
                :data-cy-restore="props.item.orderID"
                flat
                icon
                color="secondary"
              >
                <v-icon>restore</v-icon>
              </v-btn>
            </td>
            <td>{{ props.item.orderID }}</td>
            <td v-if="isAdmin">{{ props.item.ubDealerID }}</td>
            <td class="text-md-right">{{ props.item.dealerFullName }}</td>
            <td class="text-md-right">
              {{ props.item.createdDate | formatDate }}
            </td>
            <td class="text-md-right">{{ props.item.orderString }}</td>
            <td class="text-md-right">
              {{ props.item.orderStatus | orderStatus }}
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapDealerState } = createNamespacedHelpers('orders/dealer');
export default {
  name: 'OrdersNotification',
  props: {
    display: Boolean,
    orders: Array,
  },
  data() {
    return {
      headers: [
        {
          text: 'Retrieve',
          align: 'left',
          sortable: false,
          value: 'true',
        },
        {
          text: 'Order ID',
          align: 'left',
          sortable: true,
          value: 'orderID',
        },
        {
          text: 'Dealer Name',
          align: 'right',
          sortable: false,
          value: 'true',
        },
        {
          text: 'Created Date',
          align: 'right',
          sortable: true,
          value: 'createdDate',
        },
        {
          text: 'Customer / Company',
          align: 'right',
          sortable: false,
        },
        {
          text: 'Status',
          align: 'right',
          sortable: true,
          value: 'orderStatus',
        },
      ],
      rows: [
        {
          orderID: '2222',
          ubDealerID: 'Test',
          dealerFullName: 'Dealer Name',
          createdDate: new Date(),
          orderString: 'New',
          orderStatus: 'DDD',
        },
        {
          orderID: '2222',
          ubDealerID: 'Test',
          dealerFullName: 'Dealer Name',
          createdDate: new Date(),
          orderString: 'New',
          orderStatus: 'DDD',
        },
      ],
    };
  },
  computed: {
    ...mapDealerState(['dealer']),
    isAdmin: function () {
      return this.dealer.authGroup == 'Administrators';
    },
  },
};
</script>

<style></style>
